import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { occassionList } from '../services/Product-service';
import { Link } from 'react-router-dom';

function Occasion({showsbyocc, sectionTitle}) {
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [homedesignerdiscountArr, sethomedesignerdiscountArr] = useState([]);
    const [apiTitle, setApiTitle] = useState('');

    const desktopSlidesToShow = 4;
    const totalItems = homedesignerdiscountArr.length;
    const canGoPrev = currentSlide > 0;
    const canGoNext = currentSlide + desktopSlidesToShow < totalItems;

    var settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        beforeChange: (_old, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
                    arrows: false,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: totalItems > 2 ? 2 : 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: totalItems > 2 ? 2 : 1
                }
            }
        ]
    };
    var requestOptions = {
        occ_stat: 'shop_byocc'
    };
    const gethomedesignerdiscountList = () => {
        occassionList(requestOptions).then((data) => {
            sethomedesignerdiscountArr(Array.isArray(data?.data) ? data.data : []);
            setApiTitle(data?.section_ttile || data?.section_title || '');
        }).catch((error) => {
            console.error("Error fetching data list:", error);
        })
    }

    useEffect(() => {
        gethomedesignerdiscountList();
    }, [])

  return (
    showsbyocc && (
    <div>
         <div className='App'>
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer">
                        <div className="layout row justify-space-between align-center text-left SectionTitle">
                            <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {apiTitle || sectionTitle || 'SHOP BY OCCASION'} </h1>
                            <Link to="/category" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</Link>
                        </div>
                        <div className="layout">
                            <div className="flex left-align-slick xs12">
                            <div className="slider-container">
                                <button
                                    type="button"
                                    data-role="none"
                                    className={`slick-arrow slick-prev${canGoPrev ? '' : ' slick-disabled'}`}
                                    style={{ display: 'block' }}
                                    aria-disabled={!canGoPrev}
                                    onClick={() => canGoPrev && sliderRef.current?.slickPrev()}
                                />
                                <Slider ref={sliderRef} {...settings}>
                                    {homedesignerdiscountArr.map((data, index) => (
                                        <div className='item sjl' key={index}>
                                        <div className="CarouselSection category">
                                            <div className="prel Gutter">
                                            <Link to={`/category/?occasion_id=${data.id}`}>
                                                    <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                        <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                            <img src={data.thumbnail} alt={data.title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                                        </div>
                                                        <div className="animated-bg-placeholder"></div>
                                                    </div>
                                                    {/* <div className="image-gradient"></div> */}
                                                    <div className="ImageTextDetail CategoryImageTextDetail">
                                                        <label className="h4 ImageTextLabelTop m-t-5 demi-bold"> {data.title} </label>
                                                        <label className="h6 ellipsis ImageTextLabelBottom block font-normal">SHOP NOW</label>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                   ))}
                                </Slider>
                                <button
                                    type="button"
                                    data-role="none"
                                    className={`slick-arrow slick-next${canGoNext ? '' : ' slick-disabled'}`}
                                    style={{ display: 'block' }}
                                    aria-disabled={!canGoNext}
                                    onClick={() => canGoNext && sliderRef.current?.slickNext()}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    )
  )
}

export default Occasion
